<div class="genieSettingsWrapper" [formGroup]="points">

  <!-- Section Card -->
  <div class="section-card">

    <!-- Card Header -->
    <div class="card-header">
      <h3>{{ 'Customer Communication' | translate }}</h3>
      <button type="button" class="saveButton" (click)="saveChanges()" [disabled]="saving">
        {{ 'Save Changes' | translate }}
      </button>
    </div>

    <!-- Card Body -->
    <div class="card-body">

      <!-- Three Message Columns -->
      <div class="messages-grid">

        <!-- Point Message -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Point Message' | translate }}</label>
          </div>
          <textarea
            class="genie-textarea"
            formControlName="customization"
            rows="5"
            placeholder="{{ 'You earned {points} points for this purchase!' | translate }}"
          ></textarea>
        </div>

        <!-- Popup Message When Earned -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Popup Message When Earned' | translate }}</label>
          </div>
          <textarea
            class="genie-textarea"
            formControlName="popupMessage"
            rows="5"
            placeholder="{{ 'Congratulations! You just earned 10 points.' | translate }}"
          ></textarea>
        </div>

        <!-- Terms & Conditions -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Terms & Conditions' | translate }}</label>
          </div>
          <textarea
            class="genie-textarea"
            formControlName="termsConditions"
            rows="5"
            placeholder="{{ 'Points are valid for 1 year from the date of purchase...' | translate }}"
          ></textarea>
        </div>

      </div>

      <!-- Push Notifications Row -->
      <div class="toggle-row">
        <div class="toggle-info">
          <span class="toggle-label">{{ 'Push Notifications' | translate }}</span>
          <span class="toggle-desc">{{ 'Send automated notifications to customers about their points status Before Points Expire.' | translate }}</span>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" formControlName="pointsPushNotification" />
          <span class="toggle-slider"></span>
        </label>
      </div>

      <!-- Notification Message -->
      <div class="field-wrapper">
        <div class="field-label-row">
          <label>{{ 'Notification message' | translate }}</label>
        </div>
        <textarea
          class="genie-textarea genie-textarea--tall"
          formControlName="notificationDate"
          rows="4"
          placeholder="{{ 'Your points are expiring in 7 days. Use them now!' | translate }}"
        ></textarea>
      </div>

      <!-- Days Before Expiry -->
      <div class="field-wrapper field-wrapper--narrow">
        <div class="field-label-row">
          <label>{{ 'Days before expiry' | translate }}</label>
        </div>
        <div class="genie-input">
          <input type="number" formControlName="expirationDate" placeholder="7" />
        </div>
      </div>

    </div>
  </div>

</div>
